module.exports = __webpack_public_path__ + "img/product-banner.34259e34.png";